import { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';
import SceneProducts from '@elem/compCommon/SceneProducts';
import { getTabsConfig, TAB_KEY } from './config';
import styles from './index.module.scss';
import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';

export default function Preparing() {
    const { t } = useLang('outdoorrecreation');
    const { locale } = getLocal();
    const [activeTab, setActiveTab] = useState<TAB_KEY>(TAB_KEY.DAY_TRIPS);

    const tabs = useMemo(() => getTabsConfig(t, locale), [locale, t]);
    const currentTab = tabs.find((tab) => tab.key === activeTab) || tabs[0];

    const tabsContainerRef = useRef<HTMLDivElement>(null);
    const tabRefs = useRef<Map<TAB_KEY, HTMLButtonElement>>(new Map());
    const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

    const updateIndicator = useCallback(() => {
        const container = tabsContainerRef.current;
        const activeTabEl = tabRefs.current.get(activeTab);
        if (container && activeTabEl) {
            const containerRect = container.getBoundingClientRect();
            const tabRect = activeTabEl.getBoundingClientRect();
            setIndicatorStyle({
                left: tabRect.left - containerRect.left,
                width: tabRect.width,
            });
        }
    }, [activeTab]);

    useEffect(() => {
        updateIndicator();
    }, [updateIndicator]);

    useEffect(() => {
        window.addEventListener('resize', updateIndicator);
        return () => window.removeEventListener('resize', updateIndicator);
    }, [updateIndicator]);

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    return (
        <div ref={ref} className={`${styles.Preparing} GtmModuleData-section`}>
            {/* <div className="pb-layout">
                <h2 className={cn(isVisible, 'power-backup-title fade-up')}>{t('secD_title')}</h2>
            </div> */}

            <div className="preparing-sticky-wrapper">
                <div className="preparing-tabs-container">
                    <div
                        ref={tabsContainerRef}
                        className={cn(isVisible, 'preparing-tabs fade-up')}
                        style={{ '--animate-delay': '0.15s' } as React.CSSProperties}
                    >
                        <div
                            className="tab-indicator"
                            style={{
                                transform: `translateX(${indicatorStyle.left}px)`,
                                width: `${indicatorStyle.width}px`,
                            }}
                        />
                        {tabs.map((tab) => (
                            <button
                                key={tab.key}
                                ref={(el) => {
                                    if (el) tabRefs.current.set(tab.key, el);
                                }}
                                className={`tab-item ${activeTab === tab.key ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.tabLabel}
                            </button>
                        ))}
                    </div>
                </div>

                <SceneProducts
                    key={currentTab.key}
                    cards={currentTab.products}
                    className="au-preparing-products"
                    texts={{
                        buyNow: t('common_card_buyNow'),
                        more: t('common_card_more'),
                        out: t('common_card_out'),
                        listName: currentTab.title,
                        worksWith: t('works_best_with'),
                    }}
                />
            </div>
        </div>
    );
}
